export default {
  HOME: '/',
  LOGIN: '/login'
}